<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    props: {
        duration: {
            type: Number,
            default: 0.25,
        },
        initialWidth: {
            type: Number,
            default: 0,
        },
    },
    emits: ["widthChanged"],
    data: () => ({
        resizeObserver: null as ResizeObserver | null,
        currentWidth: 0,
        mountedOnce: false,
    }),
    mounted() {
        const wrapper = this.$refs.wrapper as HTMLDivElement;
        const content = this.$refs.content as HTMLDivElement;

        wrapper.style.transitionDuration = `${this.duration}s`;

        const targetWidth = content.scrollWidth;

        this.currentWidth = this.initialWidth;
        wrapper.style.width = `${this.initialWidth}px`;

        requestAnimationFrame(() => {
            wrapper.style.width = `${targetWidth}px`;
            this.currentWidth = targetWidth;
            this.mountedOnce = true;
        });

        this.resizeObserver = new ResizeObserver(() => {
            this.animateToContentWidth();
        });

        this.resizeObserver.observe(content);
    },
    beforeUnmount() {
        this.resizeObserver?.disconnect();
    },
    computed: {},
    methods: {
        async animateToContentWidth() {
            await this.$nextTick();

            const wrapper = this.$refs.wrapper as HTMLDivElement;
            const content = this.$refs.content as HTMLDivElement;

            const newWidth = content.offsetWidth;

            if (newWidth === this.currentWidth) return;

            wrapper.style.width = `${this.currentWidth}px`;

            requestAnimationFrame(() => {
                wrapper.style.width = `${newWidth}px`;
                this.currentWidth = newWidth;
            });
        },
    },
});
</script>

<template>
    <div ref="wrapper" class="transition-width flex flex--halign-c" @transitionend.self="$emit('widthChanged')">
        <div ref="content" class="transition-width-content">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.transition-width {
    overflow: hidden;
    transition-property: width;
    transition-timing-function: ease;

    .transition-width-content {
        flex: 0 0 auto;
        width: max-content;
    }
}

@include media-breakpoint-down(md) {
    .transition-width {
        width: auto !important;
        max-width: 100%;
    }

    .transition-width-content {
        width: auto;
        max-width: 100%;
    }
}
</style>
